var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTata({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_755_9199",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 44,
    height: 44
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_755_9199)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 31.2635H9.484V34.2388H6.52991V43H2.95409V34.2388H0V31.2635ZM21.767 31.2635H31.251V34.2388H28.2972V43H24.7211V34.2388H21.767V31.2635ZM9.17314 43L13.2156 31.2635H17.7246L22.2332 43H18.191L15.7033 35.396L13.0601 43H9.17314ZM30.9399 43L34.9824 31.2635H39.4919L44 43H39.9578L37.4704 35.396L34.8271 43H30.9399ZM21.5697 1C28.7732 1 34.9905 4.18762 37.7234 8.73291C33.6091 7.54146 28.8466 6.62373 23.9003 6.79872C23.1113 6.8267 22.5008 7.04365 22.5008 7.83109V26.7851C21.8937 26.8087 21.286 26.8091 20.6789 26.7865V7.83109C20.6789 7.04337 20.0683 6.8267 19.2794 6.79872C14.3139 6.62291 9.53352 7.54859 5.40806 8.7469C8.13633 4.19393 14.359 1 21.5697 1ZM38.9176 11.5755C39.1086 12.3343 39.2056 13.1161 39.2062 13.9013C39.2062 19.496 34.2943 24.2774 27.4652 26.0586L25.4505 11.7584C25.2869 10.5955 25.297 9.80422 26.2324 9.77405C31.4802 9.60483 34.5601 10.4298 38.9176 11.5755ZM15.7132 26.0685C8.86357 24.2953 3.9336 19.5067 3.9336 13.9016C3.9336 13.112 4.03187 12.3383 4.21958 11.587C8.59938 10.4348 11.6821 9.60483 16.9473 9.7746C17.883 9.80477 17.8928 10.5961 17.7292 11.759L15.7132 26.0685Z",
    fill: "#33348E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTata);
export default __webpack_public_path__ + "static/media/tata.46bd3033b90d981d530c9d1ddcca11d4.svg";
export { ForwardRef as ReactComponent };